export const ErrorFallback = () => (
  <div
    role="alert"
    style={{
      maxWidth: 480,
      margin: "80px auto",
      padding: "0 16px",
      textAlign: "center",
    }}
  >
    <h1>Something went wrong</h1>
    <p>
      This page hit an error and couldn't finish loading. Reloading usually
      fixes it.
    </p>
    <button type="button" onClick={() => window.location.reload()}>
      Reload
    </button>
  </div>
);
